export enum channelEnum {
  HAI = 'hai',
  INTEGRATION = 'integration',
}

export const roleName = `CLOUDSTUDIO_QCSLinkedRoleInHaiws`;

export const haiAuthorizationUrl = `https://console.cloud.tencent.com/cam/role/grant?roleName=${roleName}&serviceLinkedRole=1&s_url=${encodeURIComponent(location.href)}`;

export const onSignTokenScene = 'app';
